<template>
  <div class="Contact">
    <div class="header">
      <span class="iconfont icon-back" @click="Back"></span>
      <span class="title">电子合同</span>
    </div>
    <div class="main">
      <div class="mainScroll">
        <div class="title">苏州市国内一日游接待合同</div>

        <div class="content">
          <!-- 基础 -->
          <template>
            <div class="row basic">
              <span>合 同 编 号</span>
              <span v-text="contact.RegimentNo"></span>
            </div>
            <div class="row basic">
              <span>旅游者人数</span>
              <span v-text="contact.TotoalCount"></span>
            </div>
            <div class="row basic">
              <span>姓 &emsp;&emsp;&nbsp;&nbsp;名</span>
              <span v-text="contact.MainTouristName"></span>
            </div>
            <div class="row basic">
              <span>身份证号码</span>
              <span v-text="contact.MainTouristIDNumber"></span>
            </div>
            <div class="row basic">
              <span>旅行社名称</span>
              <span v-text="contact.CompanyName"></span>
            </div>
            <div class="row basic">
              <span>许 可 证 号</span>
              <span v-text="contact.CompanyLicense"></span>
            </div>
          </template>

          <!-- 导游 -->
          <template v-if="contact.Guide != null">
            <div class="row  guide">
              <div class="left">导游员</div>
              <div class="right">
                <div class="info" v-for="item in contact.Guide" :key="item.Id">
                  <div class="item">
                    <span>姓&emsp;&emsp;&nbsp;&nbsp;&nbsp;名</span>
                    <span v-text="item.Name"></span>
                  </div>
                  <div class="item">
                    <span>导 游 证 号</span>
                    <span v-text="item.IDNumber"></span>
                  </div>
                  <div class="item">
                    <span>手&emsp;机&emsp;号</span>
                    <span v-text="item.Tel"></span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="row  guide">
              <div class="left">导游员</div>
              <div class="right">
                <div class="info">
                  <div class="item">
                    <span>姓&emsp;&emsp;&nbsp;&nbsp;&nbsp;名</span>
                    <span></span>
                  </div>
                  <div class="item">
                    <span>导 游 证 号</span>
                    <span></span>
                  </div>
                  <div class="item">
                    <span>手&emsp;机&emsp;号</span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </template>

         
          <!-- 信息来源 -->
          <template>
            <div class="row trip">
              <div class="left">信息来源</div>
              <div class="right">
                <div class="info">
                  <div class="item">
                    <div class="left">线上</div>
                    <div class="right">
                      <div class="info">
                        <div class="item">
                          <span style="width:100%;">
                            <el-radio-group
                              v-model="contact.OnLine"
                              :disabled="true"
                            >
                              <el-radio label="同程">同程</el-radio>
                              <el-radio label="飞猪">飞猪</el-radio>
                              <el-radio label="携程">携程</el-radio>
                              <el-radio label="途牛">途牛</el-radio>
                              <el-radio label="驴妈妈">驴妈妈</el-radio>
                            </el-radio-group>
                          </span>
                        </div>
                        <div class="item">
                          <span>微信公众号</span>
                          <span v-text="contact.WeChatAccount"></span>
                        </div>
                        <div class="item">
                          <span>其他</span>
                          <span
                            v-text="
                              contact.OnLine != '同程' &&
                              contact.OnLine != '飞猪' &&
                              contact.OnLine != '携程' &&
                              contact.OnLine != '途牛' &&
                              contact.OnLine != '驴妈妈' &&
                              contact.OnLine != null
                                ? contact.OnLine
                                : ''
                            "
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="left">线下</div>
                    <div class="right">
                      <div class="info">
                        <div class="item">
                          <span>旅行社</span>
                          <span v-text="contact.Offline"></span>
                        </div>
                        <div class="item">
                          <span>个人</span>
                          <span v-text="contact.Personal"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 行程 -->
          <template>
            <div class="row trip">
              <div class="left">行程安排</div>
              <div class="right">
                <div class="info">
                  <div class="item">
                    <span>成 行 团 号</span>
                    <span v-text="contact.RegimentNo"></span>
                  </div>
                  <div class="item">
                    <span>出 发 时 间</span>
                    <span v-text="contact.PlayTime"></span>
                  </div>
                  <div class="item">
                    <span>出 发 地 点</span>
                    <span v-text="contact.StartPoint"></span>
                  </div>
                  <div class="item">
                    <span>返 回 地 点</span>
                    <span v-text="contact.EndPoint"></span>
                  </div>
                </div>
                <div class="point">
                  <div class="item">
                    <span>序号</span>
                    <span>游览项目</span>
                    <span>游览时间</span>
                  </div>
                  <div
                    class="item"
                    v-for="(item, index) in contact.LineDetail"
                    :key="index"
                  >
                    <span v-text="index + 1"></span>
                    <span v-text="item.Projects"></span>
                    <span v-text="item.TimeSpan + '分钟'"></span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 费用 -->
          <template>
            <div class="row fee">
              <div class="left">旅游费用及安排</div>
              <div class="right">
                <div class="info">
                  <div class="item">
                    <span>成人</span>
                    <span class="underline" v-text="contact.AdultCount"></span>
                    <span>人×</span>
                    <span class="underline" v-text="contact.AdultPrice"></span>
                    <span>元/人</span>
                  </div>
                  <div class="item">
                    <span>儿童 </span>
                    <span
                      class="underline"
                      v-text="contact.ChildrenCount"
                    ></span>
                    <span>人×</span>
                    <span
                      class="underline"
                      v-text="contact.ChildrenPrice"
                    ></span>
                    <span>元/人</span>
                  </div>
                  <div class="item">
                    <span>老年人</span>
                    <span
                      class="underline"
                      v-text="contact.ElderlyCount"
                    ></span>
                    <span>人×</span>
                    <span
                      class="underline"
                      v-text="contact.ElderlyPrice"
                    ></span>
                    <span>元/人</span>
                  </div>
                  <div class="item">
                    <span>总价： </span>
                    <span class="underline" v-text="contact.AllPrice"></span>
                    <span>元</span>
                  </div>
                  <div class="item">
                    <span>交通安排：车号 </span>
                    <span class="underline" v-text="bus"></span>
                    <span>驾驶员</span>
                    <span class="underline" v-text="driver"></span>
                  </div>
                  <div class="item">
                    <span>餐饮安排：餐饮名称</span>
                    <span
                      class="underline"
                      v-text="contact.RestaurantName"
                    ></span>
                    <span>标准</span>
                    <span
                      class="underline"
                      v-text="contact.RestaurantPrice"
                    ></span>
                    <span>元</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 温馨提示 -->
          <template>
            <div class="row  tips">
              <div class="left">温馨提示</div>
              <div class="right">
                <span>
                  1、行程景点须注明游览项目的具体内容及最短停留时间；<br />
                  2、旅游者可自愿购买人身意外保险；<br />
                  3、本合同一式两份，双方各执一份，自双方签字盖章之日起生效；<br />
                  4、参观游览、遵守规定、文明旅游、安全出行。
                </span>
              </div>
            </div>
          </template>

          <!-- 争议解决方式 -->
          <template>
            <div class="row deal">
              <div class="left">争议解决方式</div>
              <div class="right">
                <span>
                  1、协商。旅行社客服电话
                </span>
                <span class="underline" v-text="contact.ServiceTel"> </span>
                <span>；</span><br />
                <!-- <span
                  >2、投诉。国家旅游局投诉热线12301，苏州市便民服务热线12345，苏州市旅游质监执法机构投诉电话
                  0512-12345，消费者协会投诉电话0512-12315。协商或投诉调解不成的，按下列第</span
                > -->
                <span>
                  2、投诉。苏州市旅游主管机构投诉电话<span class="underline"
                    >0512-12345</span
                  >， 市消保委投诉电话<span class="underline"
                    >0512-12315</span
                  >
                  。协商或投诉调解不成的，按下列第
                </span>
                <span
                  @click="OpenPopup"
                  class="underline red"
                  v-text="contact.ResolutionType"
                ></span>
                <span>种方式解决：</span><br />
                <span>1、依法向人民法院提起民事诉讼；</span><br />
                <span>2、将争议提交</span><span class="underline">苏州</span
                ><span>仲裁委员会仲裁。</span>
              </div>
            </div>
          </template>

          <!-- 特别规定 -->
          <template>
            <div class="row  special">
              <div class="left">特别规定</div>
              <div class="right">
                根据苏州市人民政府办公室文件苏府办[2018]341号文件《市政府办公室关于印发苏州市关于加强“一日游”市场长效管理工作措施的通知》规定：严禁旅游合同指定具体购物场所。根据《旅游法》、《旅行社条例实施细则》、《江苏省旅游条例》等法律法规关于“旅行社组织、接待旅游者，不得指定具体购物场所，不得安排另行付费旅游项目”的规定，取消“一日游”旅游合同中的购物附加条款。对旅游经营企业（者）未与游客签订旅游合同，旅游合同未载明游览景区、娱乐项目的具体内容和时间，未载明交通、住宿、餐饮等旅游服务标准，以及另行推销安排自费项目、强迫或变相强迫游客消费的行为，一律依法从速处理。
                <br />游客签字确认：<br />
                <div class="sign">
                  <img
                    :src="
                      '/api/attachment/attachment/Show?Id=' +
                        contact.TouristSignAttachment
                    "
                    alt=""
                    v-if="contact.TouristSignAttachment != null"
                  />
                </div>
              </div>
            </div>
          </template>

          <!-- 游客确认 -->
          <template>
            <div class="row  check">
              <div class="item">
                <span>是否已阅读并同意下述（合同责任）条款：</span>
              </div>

              <div class="item">
                <span>旅游者（签约代表）签字：</span>
              </div>

              <div class="item">
                <div class="sign">
                  <img
                    :src="
                      '/api/attachment/attachment/Show?Id=' +
                        contact.TouristSignAttachment
                    "
                    alt=""
                    v-if="contact.TouristSignAttachment != null"
                  />
                </div>
              </div>
              <div class="item">
                <span>签约日期：</span><span v-text="contact.SignTime"></span>
              </div>
              <div class="item">
                <span>本旅游合同是您维护合法权益的重要保障，请妥善保管!</span>
              </div>
            </div>
          </template>

          <!-- 旅行社确认 -->
          <template>
            <div class="row  check">
              <div class="item">
                <span>是否已阅读并同意下述（合同责任）条款：</span>
              </div>

              <div class="item">
                <span>旅行社签章：</span>
              </div>

              <div class="item">
                <div class="sign co">
                  <img
                    :src="
                      '/api/attachment/attachment/Show?Id=' +
                        contact.CompanySignAttachment
                    "
                    alt=""
                    v-if="contact.CompanySignAttachment != null"
                  />
                </div>
              </div>
              <div class="item">
                <span>经&ensp;办&ensp;人：</span
                ><span v-text="contact.AgentName"></span>
              </div>
              <div class="item">
                <span>签约地点：</span><span v-text="contact.AgentPlace"></span>
              </div>
              <div class="item">
                <span>签约地点：</span><span v-text="contact.AgentPlace"></span>
              </div>
              <div class="item">
                <span>电&emsp;&emsp;话：</span
                ><span v-text="contact.AgentTel"></span>
              </div>
              <div class="item">
                <span>签约日期：</span><span v-text="contact.OrderTime"></span>
              </div>
              <div class="item">
                <span>营业地址：</span
                ><span v-text="contact.StoreAddress"></span>
              </div>
              <div class="item">
                <span>
                  （按《旅行社条例实施细则》规定，旅行社应当妥善保存《旅行社条例》规定的招徕、组织、接待旅游者的各类合同及相关文件、资料，以备县级以上旅游行政管理部门核查。资料的保存期，应当不少于两年。）
                </span>
              </div>
            </div>
          </template>

          <!-- 合同责任 -->
          <template>
            <div class="article">
              <div class="title">合同责任</div>
              <span style="font-weight: bold;">
                第一条 旅行社
              </span>
              <span>
                1.除法律另有规定外，旅行社对可能危及旅游者人身、财产安全的旅游项目未履行告知、警示义务，并采取防止危害发生的必要措施，造成旅游者人身损害、财产损失的，应承担相应的赔偿责任。发生危及旅游者人身安全的情形，旅行社未采取必要处置措施的，应承担相应的赔偿责任。
              </span>
              <span>
                2.旅行社距约定出发时间12小时（含12小时）以上解除合同的，应向旅游者全额退还预付旅游费用；旅行社距约定出发时间12小时之内解除合同的，还应向旅游者支付旅游费用总额20%的违约金。
              </span>
              <span>
                3.旅行社未按合同约定安排具有合法有效资质的旅游车辆、驾驶员或导游员的，应向旅游者全额退还已付旅游费用。如果因此给旅游者造成其他人身、财产损害的，旅行社还应承担相应的赔偿责任。
              </span>
              <span>
                4.旅行社在行程中弃置旅游者的，应向旅游者全额退还已付旅游费用，并承担弃置期间给旅游者造成的必要的住宿费、餐饮费、返回交通费等实际损失。如果因此给旅游者造成其他人身、财产损害的，旅行社还应承担相应的赔偿责任。
              </span>
              <span>
                5.旅行社违反合同包车游约定安排合车游的，应向旅游者支付旅游费用总额20%的违约金。出发前旅游者要求解除合同的，旅行社还应向旅游者全额退还已付旅游费用。
              </span>
              <span>
                6.旅行社及导游员、驾驶员安排旅游者在其指定的购物场所购物或以参观等形式变相安排购物（合同中明示景点含购物场所的除外）的、强迫或者变相强迫旅游者购物的，每安排或强迫一次，旅行社应向旅游者支付旅游费用总额20%的违约金。旅游者要求退货的，旅行社应自旅游者向其交付货物之日起三日内承担退货责任。
              </span>
              <span>
                7.旅行社及导游员、驾驶员安排另行付费项目的，旅行社应向旅游者全额退还另行付费项目价款。
              </span>
              <span>
                8.旅行社及导游员、驾驶员擅自缩短游览时间、遗漏旅游景点、减少旅游服务项目的，应退还旅游者相应旅游费用（约定旅游服务项目未完成时间÷总游览时间×旅游费用总额），并支付旅游费用总额20%的违约金。
              </span>
              <span>
                9.旅行社出现其他《旅行社服务质量赔偿标准》规定的需承担赔偿责任的情形，依照《旅行社服务质量赔偿标准》承担赔偿责任。
              </span>
              <span style="font-weight: bold;">
                第二条 旅游者
              </span>
              <span>
                1.旅游者不按约定支付旅游费用的，旅行社有权解除合同，旅游者应向旅行社支付业务损失费（最高不超过旅游费用总额）。
              </span>
              <span>
                2.旅游者在距约定出发时间12小时（含12小时）以上解除合同的，旅游者应向旅行社支付实际发生的费用；旅游者在距约定出发时间12小时以内解除合同的，还应向旅行社支付旅游费用总额20%的违约金（实际发生的费用与违约金总计最高不超过旅游费用总额）。旅游者未按约定时间到达约定集合出发地点，也未能在出发中途加入旅游团队的，视为旅游者在距约定出发时间12小时以内解除合同。
              </span>
              <span>
                3.旅游者在行程中解除合同或者擅自脱离旅游团队的，旅游者应向旅行社支付实际发生的费用。因此造成旅行社其他经济损失的，旅游者还应承担相应的赔偿责任。
              </span>
              <span>
                4.旅游者违反合同约定妨碍旅游行程，给旅行社造成经济损失的，应承担相应的赔偿责任。
              </span>
              <span>
                5.旅游者采取拖延行程等不正当方式解决争议，妨碍旅游行程、造成损失扩大的，应就扩大的损失承担相应的赔偿责任。
              </span>
              <span>
                6.旅游者其他过错行为给旅行社造成经济损失的，应承担相应的赔偿责任。
              </span>
              <span style="font-weight: bold;">
                第三条 不可抗力
              </span>
              <span>
                发生不可抗力等不可归责于合同任何一方的事由，按下述情况处理：
              </span>
              <span>
                1.导致合同无法履行或继续履行的，旅行社和旅游者均有权解除合同。未实际发生费用的，旅行社应向旅游者全额退还已付旅游费用；已实际发生费用的，由旅行社与旅游者协商合理分担，剩余费用退还旅游者。
              </span>
              <span>
                2.危及旅游者人身、财产安全的，旅行社应当采取相应的安全措施。因此支出的费用，由旅行社和旅游者协商合理分担。
              </span>
              <span>
                3.造成旅游者滞留的，旅行社应当采取相应安置措施。因此增加的食宿费用，由旅游者承担；增加的返回出发地的费用，由旅行社和旅游者协商合理分担。
              </span>
            </div>
          </template>

          <!-- 使用说明 -->
          <template>
            <div class="article">
              <div class="title">使用说明</div>
              <span>
                1.本合同为示范文本，供在苏州市以内的旅行社与旅游者签订国内旅游“一日游”合同时使用。
              </span>
              <span>
                2.合同双方可根据具体情况，在协商一致的基础上以书面形式对解除合同的方式、退还旅游费用及支付违约金的期限等本合同示范文本有关条款的内容进行补充、细化，补充、细化的内容不得减轻或者免除应当由旅行社承担的责任。
              </span>
              <span>
                3.本合同示范文本由苏州市旅游质量监督管理所和消费者权益保护委员会共同制定、解释。
              </span>
            </div>
          </template>
        </div>

        <div class="btn">
          <div
            v-if="
              contact.SignTime != '' &&
                (contact.OrderStatus != -2 || contact.OrderStatus != -1)
            "
          >
            <a
              :href="
                '/api/tourist/Itineraries/DownLoadOneDayContact?Id=' +
                  contact.ContactAttachment +
                  '&orderId=' +
                  orderId
              "
              >下载合同</a
            >
          </div>
        </div>
      </div>
    </div>

    <mt-popup
      v-model="popupVisible"
      popup-transition="popup-fade"
      closeOnClickModal="true"
      position="bottom"
    >
      <div class="panel">
        <div class="popupBtn">
          <span @click="popupVisible = !popupVisible">取消</span>
          <span>请选择解决方式</span>
          <span @click="ClosePopup">确定</span>
        </div>
        <div class="content">
          <div class="item" @click="onValuesChange(1)">
            <span
              :class="{
                iconfont: true,
                'icon-selected': _self.tempChange == 1
              }"
            ></span>
            <span>1、人民法院提起民事诉讼</span>
          </div>
          <div class="item" @click="onValuesChange(2)">
            <span
              :class="{
                iconfont: true,
                'icon-selected': _self.tempChange == 2
              }"
            ></span>
            <span>2、仲裁委员会仲裁</span>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderId: "",
      userId: "",
      token: "",
      contact: {},
      bus: "",
      driver: "",
      popupVisible: false,
      showToolbar: true,
      tempChange: "",
    };
  },
  methods: {
    watchRoute() {
      var _self = this;
        if (
        sessionStorage.getItem("Vue_OrderId") == null &&
        _self.$route.params.orderId == null &&
        _self.$route.query.orderId == null
        ) {
            _self.$router.push("/HomePage");
        } else {
        _self.orderId =
            _self.$route.params.orderId != null
            ? _self.$route.params.orderId
            : _self.$route.params.orderId != null
            ? _self.$route.query.orderId
            : sessionStorage.getItem("Vue_OrderId");
            _self.GetData();
        }
    },
    getUserId(orderId) {
      var _self = this;
      if (orderId != "" && orderId != null) {
        _self.axios
          .get("/api/Abutment/Common/GetUserId?orderId=" + orderId)
          .then(res => {
            if (res.status == "success") {
              _self.userId = res.data;
            } else {
            }
          })
          .catch(err => {});
      }
    },
    Back() {
       let _self = this;
        _self.$router.push({
            name: "NewContact",
            params: {
                orderId: _self.orderId,
                resolutionType: _self.contact.ResolutionType
            }
        });
    },
    DownLoad(Id) {
      let _self = this;
      _self.axios
        .get(
          "/api/Abutment/Common/DownLoadOneDayContact?Id=" +
            Id +
            "&orderId=" +
            _self.orderId
        )
        .then(res => {})
        .catch(err => {});
    },
    ClosePopup() {
      let _self = this;
      _self.popupVisible = !_self.popupVisible;
      _self.contact.ResolutionType = _self.tempChange;
    },
    OpenPopup() {
      let _self = this;
      if (_self.contact.SignTime != "") return;

      _self.tempChange = _self.contact.ResolutionType;
      _self.popupVisible = true;
    },
    onValuesChange(values) {
      let _self = this;
      _self.tempChange = values;
    },
    GetData() {
      let _self = this;
      let param = {
        Id: _self.orderId
      };
      _self.axios
        .post("/api/Abutment/Common/GetOneDayTourContact", param)
        .then(res => {
          _self.contact = res.data.contact;
          _self.contact.BusNo.forEach(item => {
            _self.bus = _self.bus + item + "、";
          });
          _self.bus = _self.bus.substring(0, _self.bus.length - 1);
          _self.contact.Driver.forEach(item => {
            _self.driver = _self.driver + item.Name + "、";
          });

          _self.driver = _self.driver.substring(0, _self.driver.length - 1);
          if (_self.contact.SignTime == "") {
            _self.$messagebox({
              title: "提示",
              message:
                "欢迎查看旅游电子合同<br>点击合同内红色下划线可以编辑内容。"
            });
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    let _self = this;
    _self.watchRoute();
  }
};
</script>

<style lang="less" scoped>
@borderWidth: 2px;

.showAgree{
  margin-top: 20px;
}
.storeText{
  font-size: 16px;
  color: red;
  font-weight: bold;
} 
* {
  font-size: 26px;
  letter-spacing: 2px;
  -webkit-text-size-adjust: none;
  word-break: break-all;
}
a {
  color: #58afec;
  letter-spacing: 2px;
  font-size: 30px;
}
.red {
  color: #e54b3d !important;
  border-bottom: 2px #e54b3d solid !important;
  text-decoration: none !important;
}
img {
  // width: 100%;
  height: 100%;
}
.Contact {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;

  .underline {
    padding: 0px 15px !important;
    border-bottom: @borderWidth solid black;
    height: 30px;
    line-height: 30px;
    word-break: break-all;
    box-sizing: border-box;
  }
  .header {
    background: white;
    padding: 10px;
    box-sizing: border-box;
    text-align: center;
    position: relative;

    .iconfont {
      position: absolute;
      left: 30px;
      top: 20px;
      font-size: 34px !important;
    }
    .title {
      font-size: 34px !important;
      letter-spacing: 3px;
    }
  }
  .main {
    margin-top: 20px;
    flex: 1;
    height: 100%;
    width: 100%;
    background: white;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 15px;
    box-sizing: border-box;

    .mainScroll {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      box-sizing: border-box;

      .title {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        font-size: 36px !important;
        letter-spacing: 3px;
      }

      .content {
        border: @borderWidth solid #dddddd;

        .row {
          border-bottom: @borderWidth solid #dddddd;
          display: flex;
          flex-wrap: nowrap;
          box-sizing: border-box;
          letter-spacing: 2px;

          span {
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
          }
        }

        .basic {
          span:nth-of-type(1) {
            border-right: @borderWidth solid #dddddd;
            flex: 1;
          }
          span:nth-of-type(2) {
            flex: 2;
            justify-content: flex-end;
          }
        }

        .guide {
          .left {
            padding: 10px;
            box-sizing: border-box;
            writing-mode: vertical-lr;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: @borderWidth solid #dddddd;
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;

            .info {
              border-bottom: @borderWidth solid #ddd;
              box-sizing: border-box;

              .item {
                display: flex;
                flex-wrap: nowrap;
                border-bottom: @borderWidth solid #ddd;
                box-sizing: border-box;

                span:nth-of-type(1) {
                  width: 220px;
                }
                span:nth-of-type(2) {
                  flex: 1;
                  justify-content: flex-end;
                }
              }
              .item:nth-last-of-type(1) {
                border: 0 !important;
              }
            }

            .info:nth-last-of-type(1) {
              border: 0 !important;
            }
          }
        }

        .trip {
          .left {
            padding: 10px;
            box-sizing: border-box;
            writing-mode: vertical-lr;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: @borderWidth solid #dddddd;
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;

            .info {
              border-bottom: @borderWidth solid #ddd;
              box-sizing: border-box;

              .item {
                display: flex;
                flex-wrap: nowrap;
                border-bottom: @borderWidth solid #ddd;
                box-sizing: border-box;

                span:nth-of-type(1) {
                  width: 220px;
                }
                span:nth-of-type(2) {
                  flex: 1;
                  justify-content: flex-end;
                }
              }
              .item:nth-last-of-type(1) {
                border: 0 !important;
              }
            }

            .info:nth-last-of-type(1) {
              border: 0 !important;
            }

            .point {
              display: flex;
              flex-direction: column;

              .item {
                display: flex;
                flex-wrap: nowrap;
                border-bottom: @borderWidth solid #ddd;
                box-sizing: border-box;

                span:nth-of-type(1) {
                  width: 120px;
                  justify-content: center;
                  border-right: @borderWidth solid #ddd;
                }
                span:nth-of-type(2) {
                  flex: 1;
                  justify-content: center;
                  border-right: @borderWidth solid #ddd;
                }
                span:nth-of-type(3) {
                  flex: 1;
                  justify-content: center;
                }
              }
              .item:nth-last-of-type(1) {
                border: 0 !important;
              }
            }
          }
        }

        .fee {
          .left {
            padding: 10px;
            box-sizing: border-box;
            writing-mode: vertical-lr;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: @borderWidth solid #dddddd;
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;

            .info {
              border-bottom: @borderWidth solid #ddd;
              box-sizing: border-box;
              .item {
                display: flex;
                flex-wrap: wrap;
                border-bottom: @borderWidth solid #ddd;
                box-sizing: border-box;
                align-items: center;
                padding: 5px 10px;
                box-sizing: border-box;
              }
              .item:nth-last-of-type(1) {
                border: 0 !important;
              }
            }

            .info:nth-last-of-type(1) {
              border: 0 !important;
            }
          }
        }

        .tips {
          .left {
            padding: 10px;
            box-sizing: border-box;
            writing-mode: vertical-lr;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: @borderWidth solid #dddddd;
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;
          }
        }

        .deal {
          .left {
            padding: 10px;
            box-sizing: border-box;
            writing-mode: vertical-lr;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: @borderWidth solid #dddddd;
          }

          .right {
            flex: 1;
            display: block;
            padding-bottom: 10px;

            span {
              display: inline !important;
            }
          }
        }

        .special {
          .left {
            padding: 10px;
            box-sizing: border-box;
            writing-mode: vertical-lr;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: @borderWidth solid #dddddd;
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;

            .sign {
              display: flex;
              width: 100%;
              // border-bottom: @borderWidth solid black;
              margin-bottom: 10px;
              height: 150px;
              justify-content: center;
            }
          }
        }

        .check {
          flex-direction: column;

          .item {
            display: flex;
            flex-wrap: wrap;
            span {
              padding: 0 10px;
            }

            .sign {
              display: flex;
              width: 100%;
              // border-bottom: @borderWidth solid black;
              margin-bottom: 10px;
              height: 150px;
              justify-content: center;
            }
            .co {
              height: 300px;
            }
          }
        }

        .article {
          padding: 10px;
          border: 0 !important;
          width: 100%;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;

          .title {
            letter-spacing: 50px;
            font-size: 42px !important;
            border: 0 !important;
          }
          span {
            text-indent: 52px;
            word-break: break-all;
          }
        }
      }

      .btn {
        margin: 50px 0;
        width: 100%;
        display: flex;

        div:nth-of-type(1) {
          flex: 1;
          font-size: 30px;
          letter-spacing: 2px;
          color: #58afec;
          text-align: center;
          padding: 10px;
          box-sizing: border-box;
        }
        div:nth-of-type(2) {
          flex: 1;
          font-size: 30px;
          letter-spacing: 2px;
          text-align: center;
          background-color: #58afec;
          color: #ffffff;
          border-radius: 5px;
          padding: 10px;
          box-sizing: border-box;
        }
        div:nth-of-type(3) {
          flex: 1;
          font-size: 30px;
          letter-spacing: 2px;
          text-align: center;
          padding: 10px;
          box-sizing: border-box;
          background-color: #58afec;
          color: #ffffff;
        }
      }
    }
  }
}

.mint-popup {
  width: 100%;
  height: 30%;

  .panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .popupBtn {
      display: flex;
      padding: 20px;
      box-sizing: border-box;

      span {
        font-size: 30px;
        border-radius: 10px;
      }

      span:nth-of-type(1) {
        padding: 10px;
        width: 100px;
        color: white;
        background: #e6a23c;
        text-align: center;
      }
      span:nth-of-type(2) {
        padding: 10px;
        flex: 1;
        text-align: center;
      }
      span:nth-of-type(3) {
        text-align: center;
        padding: 10px;
        width: 100px;
        color: white;
        background: #67c23a;
      }
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .item {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 20px 0;
        border-top: 1px solid #ddd;

        .iconfont {
          width: 25%;
          text-align: center;
          color: #67c23a;
        }
      }

      .item:nth-last-of-type(1) {
        border-bottom: 1px solid #ddd;
      }
    }
  }
}

.el-radio {
  outline: none !important;
  -webkit-tap-highlight-color: transparent;
}
.el-radio::after {
  -webkit-tap-highlight-color: transparent;
}
.el-radio:checked:after {
  -webkit-tap-highlight-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/NewMainContact.vue